/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Empresas', url: '/empresas', icon: 'CodesandboxIcon', is_bookmarked: false},
      {title: 'Balanço Energético', url: '/operation', icon: 'CodesandboxIcon', is_bookmarked: false},
    ]
  }
}
/* eslint-enable */
